<template>
  <v-container id="master-units" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="4">
        <base-material-card color="#018C74" icon="mdi-home-plus" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">TAMBAH UNIT</div>
            <div class="subtitle-2 white--text opacity-7">
              Input Master Data Unit Baru
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-autocomplete
              v-model="unitForm.tenant_id"
              :items="tenants"
              item-text="nama_profil"
              item-value="id"
              label="Pilih Tenant"
              outlined
              dense
              color="#018C74"
            />
            <v-text-field
              v-model="unitForm.nama_unit"
              label="Nama Unit"
              outlined
              dense
              color="#018C74"
            />
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="unitForm.tipe_unit"
                  label="Tipe"
                  outlined
                  dense
                  color="#018C74"
                />
              </v-col>
              <v-col cols="6">
                <v-combobox
                  v-model="unitForm.kategori_layanan"
                  :items="['BPJS', 'NON-BPJS', 'UMUM']"
                  label="Layanan"
                  outlined
                  dense
                  color="#018C74"
                  hide-selected
                  persistent-hint
                />
              </v-col>
            </v-row>
            <v-text-field
              v-model="unitForm.harga"
              label="Harga (Rp)"
              type="number"
              outlined
              dense
              color="#CFA22D"
            />
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="unitForm.kapasitas"
                  label="Kapasitas Unit"
                  type="number"
                  outlined
                  dense
                  color="#018C74"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="unitForm.kapasitas_person"
                  label="Maks Orang"
                  type="number"
                  outlined
                  dense
                  color="#018C74"
                />
              </v-col>
            </v-row>
            <v-file-input
              label="Foto Unit"
              outlined
              dense
              color="#018C74"
              prepend-icon="mdi-camera"
              @change="onFileChange"
            />

            <v-btn
              block
              color="#018C74"
              class="white--text font-weight-bold"
              @click="saveUnit"
            >
              <v-icon left>mdi-plus-box</v-icon> SIMPAN UNIT BARU
            </v-btn>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="8">
        <base-material-card
          color="#CFA22D"
          icon="mdi-monitor-dashboard"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">
              MONITORING STATUS & MANAJEMEN
            </div>
          </template>

          <v-row dense align="center" class="mt-2 mb-4">
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="filterTenant"
                :items="listTenantAktif"
                label="Pilih Tenant Aktif"
                hide-details
                dense
                outlined
                clearable
                prepend-inner-icon="mdi-office-building"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="filterUnitName"
                :items="listUnitAktif"
                label="Pilih Unit Aktif"
                hide-details
                dense
                outlined
                clearable
                prepend-inner-icon="mdi-door-open"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="filteredItems"
            class="cyber-table"
          >
            <template v-slot:item.total_tersedia="{ item }">
              <div class="d-flex align-center" style="max-width: 130px">
                <v-text-field
                  v-model="item.total_tersedia"
                  type="number"
                  dense
                  outlined
                  hide-details
                  class="cyber-input-mini mr-1"
                />
              </div>
            </template>

            <template v-slot:item.total_terisi="{ item }">
              <div class="d-flex align-center" style="max-width: 130px">
                <v-text-field
                  v-model="item.total_terisi"
                  type="number"
                  dense
                  outlined
                  hide-details
                  class="cyber-input-mini mr-1"
                />
                <v-btn x-small fab color="#018C74" @click="updateQuickStatus(item)">
                  <v-icon x-small>mdi-refresh</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:item.sisa_kosong="{ item }">
              <v-chip
                small
                :color="item.sisa_kosong > 0 ? '#018C74' : '#ff5252'"
                class="font-weight-bold"
              >
                {{ item.sisa_kosong }} Bed
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                color="#CFA22D"
                small
                class="mr-1"
                @click="openEditDialog(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="#ff5252" small @click="deleteUnit(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="editDialog" max-width="500px">
      <v-card class="glass-card border-gold">
        <v-card-title class="headline" style="color: #cfa22d"
          >Edit Detail Unit</v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="editItem.nama_unit"
                  label="Nama Unit"
                  outlined
                  color="#018C74"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editItem.tipe_unit"
                  label="Tipe"
                  outlined
                  color="#018C74"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editItem.harga"
                  label="Harga"
                  outlined
                  color="#CFA22D"
                />
              </v-col>
              <v-col cols="12">
                <v-file-input
                  label="Ganti Foto (Opsional)"
                  outlined
                  dense
                  color="#018C74"
                  @change="onEditFileChange"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="editDialog = false">Batal</v-btn>
          <v-btn color="#CFA22D" class="black--text" @click="saveEditDetail"
            >Update Data</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    filterTenant: null,
    filterUnitName: null,
    tenants: [],
    unitStatusList: [],
    editDialog: false,
    headers: [
      { text: "TENANT", value: "nama_tenant_detail" },
      { text: "UNIT", value: "nama_unit" },
      { text: "TOTAL", value: "total_tersedia", sortable: false },
      { text: "SISA UNIT", value: "total_terisi", sortable: false },
      { text: "TERISI", value: "sisa_kosong", align: "center" },
      { text: "AKSI", value: "actions", sortable: false, align: "right" },
    ],
    unitForm: {
      tenant_id: null,
      nama_unit: "",
      tipe_unit: "",
      kategori_layanan: "",
      kapasitas: 0,
      harga: 0,
      kapasitas_person: 1,
      foto_file: null,
    },
    editItem: {},
    editFile: null,
  }),
  computed: {
    filteredItems() {
      return this.unitStatusList.filter((item) => {
        const matchTenant =
          !this.filterTenant || item.nama_tenant_detail === this.filterTenant;
        const matchUnit = !this.filterUnitName || item.nama_unit === this.filterUnitName;
        return matchTenant && matchUnit;
      });
    },

    listTenantAktif() {
      let data = this.unitStatusList;
      if (this.filterUnitName) {
        data = data.filter((i) => i.nama_unit === this.filterUnitName);
      }
      return [...new Set(data.map((i) => i.nama_tenant_detail))].sort();
    },

    listUnitAktif() {
      let data = this.unitStatusList;
      if (this.filterTenant) {
        data = data.filter((i) => i.nama_tenant_detail === this.filterTenant);
      }
      return [...new Set(data.map((i) => i.nama_unit))].sort();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        const t = await axios.get(`${BASE_URL}/tenants/all`);
        this.tenants = t.data.response.data;
        this.fetchStatus();
      } catch (e) {
        console.error("Gagal load tenant", e);
      }
    },
    async fetchStatus() {
      const res = await axios.get(`${BASE_URL}/unit-status`);
      this.unitStatusList = res.data.response.data;
    },
    onFileChange(file) {
      this.unitForm.foto_file = file;
    },
    onEditFileChange(file) {
      this.editFile = file;
    },
    async saveUnit() {
      try {
        const fd = new FormData();
        Object.keys(this.unitForm).forEach((k) => {
          if (k !== "foto_file") fd.append(k, this.unitForm[k]);
        });
        if (this.unitForm.foto_file) fd.append("foto_unit", this.unitForm.foto_file);
        await axios.post(`${BASE_URL}/tenant-units`, fd);
        alert("Unit Berhasil Ditambah!");
        this.$refs.form.reset();
        this.fetchStatus();
      } catch (error) {
        alert("Gagal Simpan Master Unit");
      }
    },
    async updateQuickStatus(item) {
      try {
        await axios.put(`${BASE_URL}/unit-status/${item.id}`, {
          total_tersedia: item.total_tersedia,
          total_terisi: item.total_terisi,
        });
        this.fetchStatus();
        alert("Status Real-time Diperbarui");
      } catch (e) {
        alert("Gagal update status");
      }
    },
    openEditDialog(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    async saveEditDetail() {
      try {
        const fd = new FormData();
        fd.append("tenant_id", this.editItem.tenant_id);
        fd.append("nama_unit", this.editItem.nama_unit);
        fd.append("tipe_unit", this.editItem.tipe_unit);
        fd.append("harga", this.editItem.harga);
        if (this.editFile) fd.append("foto_unit", this.editFile);
        await axios.put(`${BASE_URL}/tenant-units/${this.editItem.unit_id}`, fd);
        this.editDialog = false;
        this.fetchStatus();
        alert("Detail Unit Berhasil Diubah");
      } catch (e) {
        alert("Gagal update detail unit");
      }
    },
    async deleteUnit(item) {
      if (confirm(`Hapus unit ${item.nama_unit}?`)) {
        try {
          await axios.delete(`${BASE_URL}/tenant-units/${item.unit_id}`);
          this.fetchStatus();
        } catch (e) {
          alert("Gagal menghapus");
        }
      }
    },
  },
};
</script>

<style scoped>
.glass-card {
  background: rgba(10, 10, 10, 0.9) !important;
  border: 1px solid rgba(1, 140, 116, 0.2) !important;
}
.cyber-table {
  background: transparent !important;
}
.cyber-input-mini >>> .v-input__control {
  min-height: 30px !important;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
